import React, { lazy } from 'react';
import { ProtectedRoute } from '@/components';

const Identity = lazy(() => import('./identity'));
const BindSuccessRedirect = lazy(() => import('./identity/bindSuccessRedirect'));

export default {
  path: 'identity',
  children: [
    {
      index: true,
      element: <ProtectedRoute title="身份认证" component={<Identity />} />,
    },
    {
      path: 'bindSuccessRedirect',
      element: <ProtectedRoute title="身份认证" component={<BindSuccessRedirect />} />,
    }
  ]
};
